import React from 'react';
import { Button } from '@mui/material';

export default function CheckBtnComponent({ url }) {
  const handleClick = () => {
    if (url) {
      window.open(url);
    }
  };

  return (
    <Button
      variant="contained"
      size="medium"
      onClick={handleClick}
      sx={{
        mt: 'auto',
        px: 3,
        py: 1,
        mb: 3,
        textTransform: 'none',
        fontWeight: 600,
        background: 'linear-gradient(135deg, #00CFC8 0%, #0088cc 100%)',
        borderRadius: 2,
        boxShadow: 2,
        '&:hover': {
          background: 'linear-gradient(135deg, #0088cc 0%, #00CFC8 100%)',
          boxShadow: 3,
        },
      }}
    >
      🚀 Check Product
    </Button>
  );
}
